import React from 'react';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>Strefa Napędu</h3>
                        <p>ul. Żółkiewskiego 4, 35-203 Rzeszów</p>
                        <p>Tel: 888 329 544</p>
                    </div>
                    <div className="footer-section">
                        <h4>Godziny otwarcia</h4>
                        <p>Pn-Pt: 8:00 - 18:00</p>
                        <p>Sb: 8:00 - 14:00</p>
                        <p>Nd: zamknięte</p>
                    </div>
                    <div className="footer-section">
                        <h4>Znajdź nas</h4>
                        <a href="https://www.google.com/maps/place/Strefa+Nap%C4%99du/@50.0455414,21.9678707,17z/data=!3m1!4b1!4m6!3m5!1s0x473cfb0a5b067467:0x74b40195e81d8c0f!8m2!3d50.045538!4d21.9704456!16s%2Fg%2F11zb5r3jy7?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-google"></i> Google Maps
                        </a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {currentYear} Strefa Napędu. Wszystkie prawa zastrzeżone.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;